import Config from "src/Constants/Config";
import CustomCenterContent from "src/Pages/CustomCenterContent";
import Page4 from "./Page4";

const PageId = 4;

const DATA = () => {
  return {
    showHeader: true,
    bgVideo: {
      video: `${Config.BASE_URL}/videos/mef.mp4`,
      poster: `${Config.BASE_URL}/images/bg_2.jpg`,
    },
    children: (
      <CustomCenterContent pageId={PageId}>
        <Page4 />
      </CustomCenterContent>
    ),
  };
};

export default DATA;
